import { createAction, props } from '@ngrx/store';
import { PhysicalAccessControlModels } from '@models/physical-access-control.models';

export const resetToInitialState = createAction('[PHYSICAL-ACCESS-CONTROL] Reset to Initial state');

export const getPhysicalAccessControl = createAction('[PHYSICAL-ACCESS-CONTROL] Get Physical Access Control');
export const getPhysicalAccessControlSuccess = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Get Physical Access Control Success',
  props<{ documents: PhysicalAccessControlModels.PhysicalAccessControlDocument[] }>(),
);
export const getPhysicalAccessControlFail = createAction('[PHYSICAL-ACCESS-CONTROL] Get Physical Access Control Fail');

export const setQueryStringFilter = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Set Query String Filter',
  props<{ prop: string; value: string }>(),
);
export const resetEntities = createAction('[PHYSICAL-ACCESS-CONTROL] Reset Entities');

export const startSavePhysicalAccessControl = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Start Save Physical Access Control',
  props<{ document: Partial<PhysicalAccessControlModels.PhysicalAccessControlDocument> }>(),
);
export const savePhysicalAccessControlRequest = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Save Physical Access Control Request',
  props<{ document: Partial<PhysicalAccessControlModels.PhysicalAccessControlDocument> }>(),
);
export const updatePhysicalAccessControl = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Update Physical Access Control Request',
  props<{ document: Partial<PhysicalAccessControlModels.PhysicalAccessControlDocument> }>(),
);

export const setCanDeactivate = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Set Can Deactivate',
  props<{ canDeactivate: boolean }>(),
);

export const savePhysicalAccessControlRequestSuccess = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Save Physical Access Control Request Success',
);
export const savePhysicalAccessControlRequestFail = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Save Physical Access Control Request Fail',
);

export const setIsSaving = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Set Is Saving',
  props<{ isSaving: boolean }>(),
);

export const startDeletePhysicalAccessControl = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Start Delete Physical Access Control',
  props<{ id: string }>(),
);
export const deletePhysicalAccessControl = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Delete Physical Access Control',
  props<{ id: string }>(),
);
export const deletePhysicalAccessControlSuccess = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Delete Physical Access Control Success',
  props<{ id: string }>(),
);
export const deletePhysicalAccessControlFail = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Delete Physical Access Control Fail',
);

export const getOnePhysicalAccessControl = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Get One Physical Access Control',
  props<{ id: string }>(),
);
export const getOnePhysicalAccessControlSuccess = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Get One Physical Access Control Success',
  props<{ document: PhysicalAccessControlModels.PhysicalAccessControlDocument }>(),
);
export const getOnePhysicalAccessControlFail = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Get One Physical Access Control Fail',
);

export const changeFormValidation = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Change Form Validation',
  props<{ isFormValid: boolean }>(),
);

export const testPhysicalAccessControl = createAction('[PHYSICAL-ACCESS-CONTROL] Test Physical Access Control');
export const testPhysicalAccessControlSend = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Test Physical Access Control Send',
  props<{ request: PhysicalAccessControlModels.TestPhysicalAccessControlRequest }>(),
);
export const testPhysicalAccessControlSuccess = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Test Physical Access Control Success',
);
export const testPhysicalAccessControlError = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Test Physical Access Control Error',
);

export const setSelectedPhysicalAccessControl = createAction(
  '[PHYSICAL-ACCESS-CONTROL] Set Selected Physical Access Control',
  props<{ document: PhysicalAccessControlModels.PhysicalAccessControlDocument }>(),
);


